import { withErrorBoundary } from 'app/components/error-boundary';

import type { NavigationScreen } from 'app/types/navigation';
import { View } from 'react-native';
import { PresentCommunityScreenBody } from './present-community-screen-body';
import { usePresentCommunityScreen } from './use-present-community-screen';
import { useModalCardLayout } from './use-modal-card-layout';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

const PresentCommunityScreenComponent: NavigationScreen<'presentCommunity'> = ({ navigation }) => {
  const { cardWidth, cardHeight, maxWidth, onCardLayout } = useModalCardLayout();
  const screenState = usePresentCommunityScreen({ navigation });

  return (
    <View style={{ flex: 1, backgroundColor: theme.colors['surface.overlay'] }}>
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          paddingHorizontal: theme.spacing['spacing.general.x4'],
        }}
      >
        <View
          onLayout={onCardLayout}
          style={{
            width: cardWidth,
            height: cardHeight,
            maxWidth,
            borderRadius: theme.borderRadii['radius.xl'],
            overflow: 'hidden',
            backgroundColor: theme.colors['surface.tertiary'],
          }}
        >
          <PresentCommunityScreenBody {...screenState} />
        </View>
      </View>
    </View>
  );
};

export const PresentCommunityScreen: NavigationScreen<'presentCommunity'> = withErrorBoundary(
  PresentCommunityScreenComponent,
);
